import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function ComoFunciona() {
  const steps = [{
    title: 'Diagnóstico de tu perfil digestivo',
    desc: 'El primer paso del Protocolo Digestivo de 72 Horas™ es entender qué está ocurriendo en tu cuerpo. Identificás si tu reflujo es por fermentación, por estrés crónico, por hábitos de horario o por una combinación. Cada caso tiene su solución específica.'
  }, {
    title: 'Primeras 24 horas: calmar la inflamación',
    desc: 'Ajustes simples en lo que comés y cuándo lo comés para que el sistema digestivo empiece a tranquilizarse. Sin dietas extremas. Sin hambre. Sin listas de 40 alimentos prohibidos.'
  }, {
    title: 'Horas 24 a 48: identificar los detonantes reales',
    desc: 'Aplicás el sistema de identificación del protocolo para saber con precisión qué activa tu reflujo. Muchas personas descubren que el 80% de sus síntomas viene de 2 o 3 hábitos específicos — no de "todo lo que comen".'
  }, {
    title: 'Horas 48 a 72: rutina digestiva correcta',
    desc: 'Instalás la rutina digestiva que tu cuerpo necesita. Horarios de comida, forma de cenar, postura al dormir. Pequeños cambios con gran impacto en los síntomas nocturnos.'
  }, {
    title: 'Resultado: comer y dormir sin miedo',
    desc: 'Al finalizar las 72 horas, tenés claridad sobre qué te afecta, los síntomas comienzan a reducirse y ya no dependés de un medicamento para pasar el día. El Protocolo Digestivo de 72 Horas™ te devuelve algo que creías perdido: la tranquilidad de comer.'
  }];
  return <section id="como-funciona" className="bg-crema py-[100px]" data-id="element-94">
      <div className="container-custom" data-id="element-95">
        <SectionHeader eyebrow="Paso a paso" title={<>
              Cómo funciona el
              <br data-id="element-97" />
              Protocolo Digestivo de 72 Horas™
            </>} theme="light" data-id="element-96" />

        <div className="flex flex-col gap-0 mt-[60px] relative" data-id="element-98">
          <div className="absolute left-[28px] top-0 bottom-0 w-[1px] bg-gradient-to-b from-verde-claro to-transparent" data-id="element-99" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15,
          duration: 0.5,
          type: 'spring',
          stiffness: 100
        }} className="flex gap-8 py-8 border-b border-black/5 last:border-b-0 items-start relative z-10" data-id="element-100">
              <motion.div initial={{
            scale: 0,
            rotate: -180
          }} whileInView={{
            scale: 1,
            rotate: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.15 + 0.2,
            duration: 0.5,
            type: 'spring',
            stiffness: 150
          }} className="shrink-0 w-14 h-14 bg-verde text-blanco rounded-full flex items-center justify-center font-display text-[22px] font-bold" data-id="element-101">
                {idx + 1}
              </motion.div>
              <div data-id="element-102">
                <h3 className="font-display text-[20px] font-bold text-verde-oscuro mb-2.5" data-id="element-103">
                  {step.title}
                </h3>
                <p className="text-[15px] text-gris leading-[1.7]" data-id="element-104">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}